import React from "react"
import { connect } from "react-redux"
import { Button } from "buoy-core"
import { startOver } from "../../interview/actions"
import {
  Container,
  Bubble,
  getChatIcon,
} from "../../interview/components/ChatBubble"
import Text from "../../common/components/Text"
import OptionContainer from "../../interview/components/OptionContainer.js"

const EmptyCompletion = ({ startOver, brandConfigs, item }) => (
  <React.Fragment>
    <Container question>
      <Bubble question isLast>
        {getChatIcon({ brandConfigs, item })}
        <Text>
          Hmm. I’m having trouble finding a match for what you’ve described –
          but we can still figure this out. Please start over and try phrasing
          your symptoms differently.
        </Text>
      </Bubble>
    </Container>
    <OptionContainer>
      <Button onClick={startOver}>Start Over</Button>
    </OptionContainer>
  </React.Fragment>
)

const mapDispatchToProps = dispatch => ({
  startOver: () => {
    dispatch(startOver())
  },
})

const EmptyCompletionContainer = connect(
  null,
  mapDispatchToProps
)(EmptyCompletion)

export { EmptyCompletionContainer as default, EmptyCompletion }



// WEBPACK FOOTER //
// ./assets/completion/components/EmptyCompletion.js